import { useAppSelector } from 'redux/hooks';
import { locationSelectors } from 'redux/modules/Location';

export const useCurrentLocation = () =>
  useAppSelector(locationSelectors.getCurrentLocation);
